import React from 'react';
import styled from 'styled-components';
import Header from './Components/Header';
import { Trans, useTranslation } from 'react-i18next';
import ActivateNow from './Components/ActivateNow';
import { eonImages } from '../Theming/images';
import { themeColor } from '../Theming';
import {
  navigateToAndroidSettings,
  onClose,
} from '../Common/KindredAndroidInterface/KindredAndroidInterface';
import {
  ANALYTICS_PAGE_NAMES,
  trackClickedActionEvent,
} from '../Common/Analytics/utils';
import { usePageViewTracking, useQuery } from '../Common/Hooks';
import { normalizeText } from './utils';

const Container = styled.main`
  flex-direction: column;
  display: flex;
  flex: 1;
  max-width: 600px;
  margin: 0 auto;
`;

const BottomContent = styled.section`
  flex-direction: column;
  padding-bottom: 24px;
`;

const Title = styled.h1`
  font-size: ${normalizeText(36)}px;
  font-weight: 700;
  color: ${themeColor('white')};
  text-align: center;
  margin-top: 20px;
  font-family: Helvetica;
  padding-inline: 10px;
`;

const DisclaimerContainer = styled.div`
  background-color: ${themeColor('white')};
  margin-inline: 30px;
  border-radius: 10px;
  padding: 10px;
  overflow: auto;
  max-height: 25vh;
  flex-grow: 1;
  font-family: Helvetica;
  color: ${themeColor('black')};
  font-weight: normal;
  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.1);
`;

const DisclaimerParagraph = styled.p`
  font-family: Helvetica;
  color: ${themeColor('black')};
  font-weight: normal;
  margin: 0;
  padding-bottom: 15px;
  font-size: 15px;

  & > a {
    color: ${themeColor('black')};
    text-decoration: underline;
`;

const DisclaimerHeading = styled.h2`
  font-family: Helvetica-Bold;
  color: ${themeColor('black')};
  font-weight: normal;
  margin: 0 0 5px 0;
  padding: 0;
  font-size: 16px;
  font-weight: 700;
`;

const EonPluginActivationAndroidAccessibility: React.FC = () => {
  const { t } = useTranslation();
  const query = useQuery();
  const { accessibility_instructions_page } = ANALYTICS_PAGE_NAMES;
  usePageViewTracking(accessibility_instructions_page, 'Eon');

  const renderContent = () => {
    return (
      <Container>
        <Header
          height="20vh"
          titleContent={
            <Title>{t('eon.enableAccessibilityPermissions')}</Title>
          }
          image={eonImages.eon_header_generic}
        />
        <DisclaimerContainer tabIndex={0}>
          <Trans i18nKey="eon.accessibilityDisclaimer" t={t}>
            <DisclaimerParagraph>
              <a href="mailto:Eonnext@kindredteam.com">
                Eonnext@kindredteam.com
              </a>
            </DisclaimerParagraph>
            <DisclaimerHeading />
          </Trans>
        </DisclaimerContainer>
        <BottomContent>
          <ActivateNow
            navigateToSettings={() => {
              navigateToAndroidSettings();
              trackClickedActionEvent(
                query,
                'Eon',
                'agree',
                accessibility_instructions_page
              );
            }}
            close={() => {
              onClose?.();
              trackClickedActionEvent?.(
                query,
                'Eon',
                'disagree',
                accessibility_instructions_page
              );
            }}
            title={t('eon.activateNow')}
            msg={t('eon.activateAccessibility')}
            steps={[
              t('eon.tapAgree'),
              t('eon.tapInstalledApps'),
              t('eon.toggleEon'),
            ]}
          />
        </BottomContent>
      </Container>
    );
  };

  return renderContent();
};

export default EonPluginActivationAndroidAccessibility;
